import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Box, InputAdornment } from '@mui/material';
import clsx from 'clsx';
import GenericInput from '../../genericInput/GenericInput';
import { Translation } from '../../Translation';
import phoneWithPrefixStyles from './phoneWithPrefix.styles';
const PhoneWithPrefix = props => {
    const { label, required, id, onChange, onFocus, onBlur, value, options, placeholder, rawErrors, disabled, schema, classes, } = props;
    const { readOnly, disabled: schemaDisabled } = schema;
    const handleChange = useCallback((e) => {
        onChange(e.target.value);
    }, [onChange]);
    const handleBlur = useCallback(() => {
        onBlur && onBlur(id, value);
    }, [onBlur, id, value]);
    const currentError = useMemo(() => rawErrors?.[0] ?? undefined, [rawErrors]);
    const styles = phoneWithPrefixStyles();
    const isDisabled = disabled || schemaDisabled;
    return (_jsx(GenericInput, { label: label, required: required, id: id, value: value, currentError: currentError
            ? {
                props: {
                    id: currentError,
                    defaultMessage: currentError,
                },
            }
            : undefined, onChange: handleChange, onFocus: onFocus, onBlur: handleBlur, inputMode: options?.inputType, inputLabel: !!options?.inputLabel || !!label, placeholder: placeholder, disabled: isDisabled, readOnly: readOnly, startAdornment: _jsx(InputAdornment, { position: "start", classes: {
                root: clsx(styles.startAdornment, classes?.startAdornment, {
                    [styles.disabled]: isDisabled,
                    ...(classes?.disabled && {
                        [classes.disabled]: isDisabled,
                    }),
                }),
            }, children: _jsx(Box, { className: clsx(styles.phonePrefix, classes?.phonePrefix), "data-test": `text_input:prefix:${id}`, children: _jsx(Translation, { id: "trans__checkout__enquiry_form__phone_prefix", component: "Typography", componentProps: { variant: 'body1' } }, void 0) }, void 0) }, void 0), classes: {
            root: clsx(styles.root, classes?.root),
            fieldWrapper: clsx(styles.fieldWrapper, classes?.fieldWrapper),
            input: clsx(styles.input, styles.phoneInput, classes?.input, classes?.phoneInput),
            errorText: clsx(styles.errorText, classes?.errorText),
            notchedOutline: clsx(styles.notchedOutline, classes?.notchedOutline),
            focused: clsx(styles.focused, classes?.focused),
            inputError: clsx(styles.inputError, classes?.inputError),
            helperTextError: clsx(styles.helperTextError, classes?.helperTextError),
            dateCalendar: clsx(styles.dateCalendar, classes?.dateCalendar),
            label: clsx(styles.label, classes?.label),
            noOptions: clsx(styles.noOptions, classes?.noOptions),
            inputNoLabel: clsx(styles.inputNoLabel, classes?.inputNoLabel),
            labelContainer: clsx(styles.labelContainer, classes?.labelContainer),
            labelAsterisk: clsx(styles.labelAsterisk, classes?.labelAsterisk),
            disabled: clsx(styles.disabled, classes?.disabled),
        } }, void 0));
};
export default PhoneWithPrefix;
//# sourceMappingURL=PhoneWithPrefix.js.map